import { dateTime, dateToISO } from '../../shared/packages/dateTime';
import { fieldNames } from '../../shared/configs/acceptanceForm';
import { createMapDesksToForm, mapDesks } from './mapDesks';
import { mapToPayload } from './mapToPayload';
import { asIs, mapHouses, mapRelatedAddresses } from './methods';
import { getValuesFromStore } from './getValuesFromStore';

const createAcceptanceMapper = {
  [fieldNames.main.companyId]: asIs,
  [fieldNames.main.houses]: mapHouses,
  [fieldNames.main.relatedAddresses]: mapRelatedAddresses,
  [fieldNames.main.addressesForExceptions]: asIs,
  [fieldNames.main.name]: asIs,
  [fieldNames.main.fromDate]: dateToISO,
  [fieldNames.main.toDate]: dateToISO,
  [fieldNames.main.workers]: asIs,
  [fieldNames.main.desks]: mapDesks,
};

const mapFormValuesToPayload = (values, isDraft = false) =>
  mapToPayload(values, createAcceptanceMapper, isDraft);

const changeDesksSettingsMapper = {
  [fieldNames.main.configId]: asIs,
  [fieldNames.main.fromDate]: dateToISO,
  [fieldNames.main.toDate]: dateToISO,
  [fieldNames.main.desks]: mapDesks,
};

const mapDesksSettingsValuesToPayload = (values) =>
  mapToPayload(values, changeDesksSettingsMapper);

const createNewConfigMapper = {
  acceptanceId: asIs,
  [fieldNames.main.fromDate]: dateToISO,
  [fieldNames.main.toDate]: dateToISO,
  [fieldNames.main.desks]: mapDesks,
};

const mapNewConfigValuesToPayload = (values) =>
  mapToPayload(values, createNewConfigMapper);

const createDesksConfigsToFormMapper = ({ desksMap, timeIntervals }) => {
  const mapDesks = createMapDesksToForm({ desksMap, timeIntervals });

  return {
    [fieldNames.main.configId]: asIs,
    [fieldNames.main.fromDate]: dateTime,
    [fieldNames.main.toDate]: dateTime,
    [fieldNames.main.desks]: mapDesks,
  };
};

const mapDesksConfigsToForm = (configs, { desksMap, timeIntervals }) => {
  const mapper = createDesksConfigsToFormMapper({
    desksMap,
    timeIntervals,
  });

  return mapToPayload(configs, mapper);
};

export {
  mapFormValuesToPayload,
  getValuesFromStore,
  mapNewConfigValuesToPayload,
  mapDesksConfigsToForm,
  mapDesksSettingsValuesToPayload,
};
